import { render, staticRenderFns } from "./demoRecord.vue?vue&type=template&id=1991a384"
import script from "./demoRecord.vue?vue&type=script&lang=js"
export * from "./demoRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports